import React from "react";
import { FileType } from "../../../lib/utils/file-utils";
import { PdfPreview } from "./pdf-preview.component";
import { StlThumbnailPreview } from "./stl-thumbnail-preview.component";
import { XmlPreview } from "./xml-preview.component";

interface FilePreviewProps {
	url: string;
	fileType: FileType;
	fileName?: string;
	width?: number;
}

export const FilePreview: React.FC<FilePreviewProps> = ({
	url,
	fileType,
	fileName,
	width,
}) => {
	if (fileType === "img") {
		return <img src={url} className="h-full w-full object-cover" />;
	}

	if (fileType === "video") {
		return (
			<video className="h-full w-full object-cover">
				<source
					src={url}
					type={`video/${fileName?.split(".").pop()}`}
				/>
			</video>
		);
	}

	if (fileType === "pdf") {
		return <PdfPreview url={url} width={width} />;
	}

	if (fileType === "3d") {
		return <StlThumbnailPreview url={url} />;
	}

	if (fileType === "xml") {
		return <XmlPreview url={url} width={width} />;
	}

	return (
		<div className="flex items-center justify-center h-full w-full text-center text-gray-600">
			<div>Dateityp nicht unterstützt. In neuem Fenster öffnen</div>
		</div>
	);
};
